module.exports = new __parcel__URL__("neon_gold_mine_level_12.2fb16144.png").toString();